import { render } from "./ForumDetailModal.vue?vue&type=template&id=180a2573&scoped=true"
import script from "./ForumDetailModal.vue?vue&type=script&lang=js"
export * from "./ForumDetailModal.vue?vue&type=script&lang=js"

import "./ForumDetailModal.vue?vue&type=style&index=0&id=180a2573&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180a2573"]])

export default __exports__